import { noWagerGames } from "@shared/sagas/games";
import { useEffect, useState } from "react";

type TResponse = [TGames];

type TGames = {
  list: TGame[];
};

type TGame = {
  game_section_id: number;
  name: string;
  section_name: string;
  string_id: string;
};

type TProviderGames = {
  [key: string]: TGame[];
};

export const useNoWagerGames = () => {
  const [games, setGames] = useState<TProviderGames | null>(null);

  const filteredByProviders = (games: TGame[]) => {
    return games.reduce((acc, game) => {
      if (!acc[game.section_name]) {
        acc[game.section_name] = [];
      }

      acc[game.section_name].push(game);

      return acc;
    }, {} as Record<string, TGame[]>);
  };

  useEffect(() => {
    const fetchGames = async () => {
      const res = (await noWagerGames()) as unknown as TResponse;
      const list = res[0]?.list;
      const withProviders = filteredByProviders(list);

      if (list) {
        setGames(withProviders);
      }
    };

    fetchGames();

    return () => {
      setGames(null);
    };
  }, []);
  return {
    noWagerGames: games,
  };
};
